import { Link, List, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import { ImportExport } from "@material-ui/icons";
import { Collections } from "Collections";
import { FullscreenLoading } from "components/FullscreenLoading";
import { useOrg } from "components/OrgProvider";
import { useOrgUser } from "components/OrgUserProvider";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { Grant } from "models/Grant";
import { getOrgUserGrants } from "models/OrgUser";
import { noPriceFieldNameText, PriceField } from "models/PriceField";
import { PriceFieldCategories } from "models/PriceFieldCategories";
import { Paths } from "Paths";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { formatMoney } from "screens/Offer/CreateOffer/SummaryTable";
import { ListScreen } from "../ListScreen";



const getName = (priceField: PriceField) => noPriceFieldNameText(priceField.name?.text)
const getNamePrefix = (priceField: PriceField) => priceField.template ? (
    <>
        <Link component={RouterLink} to={Paths.PRICE_FIELD_TEMPLATES + '/' + priceField.template.id}>Mal</Link>{' - '}
    </>
) : null

export function PriceFieldsScreen() {
    const [org, loadingOrg] = useOrg()
    const [orgUser, loadingOrgUser] = useOrgUser()

    const loading = loadingOrg || loadingOrgUser

    if (loading) {
        return <FullscreenLoading screenId="Price Fields Screen" />
    }
    const grants = getOrgUserGrants(orgUser?.data || null)
    const canCreate = !!grants?.[Grant.CREATE_PRICE_FIELD]
    const canDelete = !!grants?.[Grant.DELETE_PRICE_FIELD]

    return (
        <ListScreen<PriceField>
            standardBackButton
            title="Prisfelter"
            canCreate={canCreate}
            canDelete={canDelete}
            collectionName={Collections.PRICE_FIELDS}
            getQuery={(query, path) => org && query.where(path.data.org.id, '==', org.data.id)}
            loadingQueryData={loadingOrg}
            persist
            getName={getName}
            getNamePrefix={getNamePrefix}
            noEntriesText="Du har ingen prisfelter enda"
            createNewText="Trykk her for å lage ett nytt prisfelt"
            fieldName="priceField"
            path={Paths.PRICE_FIELDS}
            createPath={Paths.CREATE_PRICE_FIELD}
            dense
            getSecondaryText={priceField => (!Object.values(priceField.categories.map).length ? (
                <Typography variant="subtitle2" color="secondary">Har ingen kategorier</Typography>
            ) : (
                formatMoney(priceField.price) + '  ' + PriceFieldCategories.FlatList.filter(category => !!priceField.categories.map[category.id]).map(category => category.name).join(', ')
            ))}
            deleteProps={{
                deleteEvent: AnalyticsEvent.REMOVED_PRICE_FIELD,
                deleteErrorEvent: AnalyticsEvent.DELETE_PRICE_FIELD_ERROR,
                deleteContextEvent: AnalyticsEvent.REMOVED_PRICE_FIELD,
            }}
            copyProps={{
                copyEvent: AnalyticsEvent.CREATED_PRICE_FIELD,
                copyErrorEvent: AnalyticsEvent.CREATE_PRICE_FIELD_ERROR,
                copyContextEvent: AnalyticsEvent.COPIED_PRICE_FIELD,
            }}
            getErrorEvent={AnalyticsEvent.GET_PRICE_FIELDS_ERROR}
            aboveList={(
                <List dense>
                    <ListItem
                        component={RouterLink}
                        to={Paths.IMPORT_PRICE_FIELD_TEMPLATES}
                    >
                        <ListItemIcon>
                            <ImportExport />
                        </ListItemIcon>
                        <ListItemText
                            primary="Importer maler"
                            secondary="Trykk her for å se maler for din bransje"
                        />
                    </ListItem>
                </List>
            )}
        />
    )
}
